<template lang="">
    <ChartLine 
        id="chart"
        :chart-options="options"
        :chart-data="chartData"
        :width="100"
        :height="50"
    />
</template>
<script>
import { Line as ChartLine} from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { LineColors } from '../constants';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale, zoomPlugin);

export default {
    name: "ComboioChart",
    components: { ChartLine },
    props: {
        posicoes: {
            type: Array,
            required: true
        },
        viagens: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        loading: false,
        options: {
            responsive: true,
            maintainAspectRatio: true,
            animation: false,
            scales: {
                x: {
                    display: false,
                },
                y: {
                    display: false,
                }
            },
            plugins: {
                zoom: {
                    zoom: {
                        wheel: {
                            enabled: true
                        },
                        mode: 'x'
                    },
                    pan: {
                        enabled: true,
                        mode: 'x'
                    }
                }
            }
        },
        posicoesVeiculo: {
            label: null,
            data: null,
            borderColor: null,
        },
        datasets: [],
        labels: [],
    }),
    created() {
        this.populaLabels();
        this.populaDatasets();
    },
    computed: {
        posicoesAjustadas() {
            return this.posicoes.filter((p) => 
                p.dt_posicao <= this.viagens.toSorted((a, b) => new Date(a.dt_inicio) - new Date(b.dt_inicio))[this.viagens.length - 1].dt_fim)
                    .sort((a, b) => new Date(a.dt_posicao) - new Date(b.dt_posicao));
        },
        chartData() {
            return {
                title: {
                    display: true,
                    text: this.$t('nav.reports.convoy')
                },
                labels: this.labels,
                datasets: this.datasets,
            }
        },
    },
    methods: {
        populaLabels() {
            this.labels = this.posicoesAjustadas.map((p) => p.dt_posicao_extenso);
        },
        populaDatasets() {
            this.datasets = [];
            let idVeiculos = new Set(this.posicoesAjustadas.map((p) => p.id_carro));
            let contagem = 0;
            for (let id of idVeiculos) {
                let progressos = [];
                let viagensFiltered = this.viagens.filter((v) => v.id_veiculo === id);
                for (let viagem of viagensFiltered) {
                    if (viagem.id_sentido !== 1 && viagem.id_sentido !== 2) {
                        continue;
                    }

                    let valor_inicial = viagem.id_sentido === 1 ? 0 : 100;
                    let valor_final = viagem.id_sentido === 1 ? 100 : 0;

                    for (let i = 0; i < this.posicoesAjustadas.length; i++) {
                        if (this.posicoesAjustadas[i].dt_posicao == viagem.dt_inicio) {
                            progressos.push({index: i, progresso: valor_inicial});
                        } else if (this.posicoesAjustadas[i].dt_posicao == viagem.dt_fim) {
                            progressos.push({index: i, progresso: valor_final});
                        }
                    }
                }

                let data = [];

                for (let i = 0; i < this.posicoesAjustadas.length; i++) {
                    let index = progressos.findIndex((p) => p.index === i)
                    if (index === -1) {
                        data.push(null);
                    } else {
                        data.push(progressos[index].progresso);
                    }
                }
                
                this.posicoesVeiculo = { 
                    label: this.posicoesAjustadas.find((p) => p.id_carro === id).numero_ordem, 
                    data: data, 
                    borderColor: LineColors[contagem],
                    backgroundColor: LineColors[contagem],
                    pointRadius: 2,
                    spanGaps: true,
                }
                this.datasets.push(this.posicoesVeiculo);
                contagem = contagem < LineColors.length ? contagem + 1 : 0;
            }
        },
    },
}
</script>
<style lang="">
    
</style>